import * as BagModule from '../bag';
import * as Messages from '../messages';
import * as BagCloseTime from '../masthead/header';
import bagReturned from './bag-returned.json';
import bagItems from './bag-items.json';

const setKlaviyo = () => {
  window.klaviyo = { track: jest.fn() };
};

const checkBraOrBacksMatch = (returnedItem, arrayNumber) => {
  const bag = bagReturned[returnedItem];
  const stateItems = [bagItems[arrayNumber]];
  const code = stateItems[0]?.code;
  const quantityParam = 99;

  const getState = jest.fn(() => ({
    app: {
      config: { currency: 'GBP' },
      locale: { selected: 'en-GB' },
    },
    bag: { items: stateItems },
  }));
  const dispatch = jest.fn();

  BagModule.addToBagSuccess(bag, code, quantityParam)(dispatch, getState);

  expect(window.klaviyo.track).toHaveBeenCalledTimes(1);

  const [eventName, payload] = window.klaviyo.track.mock.calls[0];
  expect(eventName).toBe('Added to Cart');

  const product = stateItems.find(i => i.code === code);
  expect(product).toBeTruthy();

  const expectedAddedItem = {
    $value: bag.subTotal,
    AddedBackSize: product.size.back || '',
    AddedCupSize: product.size.cup || '',
    AddedSize: product.size.size || '',
    AddedItemColour: product.colour,
    AddedItemProductName: `${product.brandName} ${product.styleName} in ${product.colour}`,
    AddedItemProductID: product.styleCode,
    AddedItemSKU: product.code,
    AddedItemCategories: [product.category],
    AddedItemImageURL: `https:${product.imgUrl}`,
    AddedItemURL: `localhost${product.url}`,
    AddedItemPrice: product.price,
    AddedItemCurrency: 'GBP',
    AddedItemQuantity: product.quantity,
    AddedStockStatus: product.stockStatusDisplay,
    CheckoutURL: `localhost/bag`,
  };

  expect(payload).toMatchObject(expectedAddedItem);

  const expectedItemNames = bag.items.map(
    item => `${item.brandName} ${item.styleName} in ${item.colour}`
  );
  expect(payload.ItemNames).toEqual(expectedItemNames);

  payload.Items.forEach((it, idx) => {
    const source = bag.items[idx];
    expect(it).toMatchObject({
      ProductID: source.styleCode,
      SKU: source.code,
      Colour: source.colour,
      ProductName: `${source.brandName} ${source.styleName} in ${source.colour}`,
      Quantity: source.quantity,
      ItemPrice: source.price,
      ItemCurrency: 'GBP',
      RowTotal: source.quantity * source.price,
      ProductURL: `localhost${source.url}`,
      ImageURL: `https:${source.imgUrl}`,
      ProductCategories: [source.category],
      StockStatus: source.stockStatusDisplay,
    });

    expect(payload.AddedCupSize).toBe(source.size.cup || '');
    expect(payload.AddedBackSize).toBe(source.size.back || '');
    expect(payload.AddedSize).toBe(source.size.size || '');
  });
};

describe('addToBagSuccess: first block', () => {
  beforeEach(() => {
    jest.clearAllMocks();
  });
  const returnedItem = bagReturned.bra;
  it('dispatches receiveBag, addMessage, startPopoverBagCloseTimer, and reads state', () => {
    const addMessage = jest.fn();
    addMessage(Messages, 'addMessage');

    const startPopover = jest.fn();
    startPopover(BagCloseTime, 'startPopoverBagCloseTimer');

    const dispatch = jest.fn();
    const mockState = {
      app: {
        config: { currency: 'GBP' },
        locale: { selected: 'en-GB' },
      },
      bag: { items: [bagItems[0]] },
    };
    const getState = jest.fn(() => mockState);

    const bag = { returnedItem };
    const code = 'LN566BLK30E';
    const quantity = 1;

    BagModule.addToBagSuccess(bag, code, quantity)(dispatch, getState);

    expect(dispatch).toHaveBeenCalledWith(
      expect.objectContaining({
        type: 'bravissimo/bag/RECEIVE',
        payload: { returnedItem },
      })
    );
    expect(addMessage).toHaveBeenCalled();
    expect(startPopover).toHaveBeenCalled();

    expect(getState).toHaveBeenCalledTimes(1);
  });
});

describe('addToBagSuccess: klaviyo if-block', () => {
  beforeEach(() => {
    jest.clearAllMocks();
    setKlaviyo();
  });
  it('does NOT call klaviyo.track when guard conditions fail', () => {
    const bag = bagReturned;
    const stateItems = bagItems;

    window.klaviyo = undefined;
    BagModule.addToBagSuccess(
      bag,
      stateItems[0].code,
      1
    )(jest.fn(), () => ({
      app: { config: { currency: 'USD' }, locale: { selected: 'en-US' } },
      bag: { items: stateItems },
    }));
    expect(window.klaviyo?.track).toBeUndefined();
  });

  it('will return size: M and no band or cup size if a brief of medium size', () => {
    checkBraOrBacksMatch('briefs', 1);
  });
  it('will return size: 30E and band size 30 and cup size E if bra for 30E added to basket', () => {
    checkBraOrBacksMatch('bra', 0);
  });
});
